var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"top-section text-center"},[_c('NavBar'),_c('Section1'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }